var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgECheck2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 42,
    viewBox: "0 0 62 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 41,
    rx: 5.5,
    fill: "#F3F9FF",
    stroke: "#CED9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 52,
    height: 32,
    rx: 3,
    stroke: "#CED9F9",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7778 17.1623C18.7778 16.7173 18.6901 16.2766 18.5198 15.8655C18.3495 15.4543 18.0999 15.0807 17.7852 14.766C17.4705 14.4513 17.0969 14.2017 16.6858 14.0314C16.2746 13.8611 15.8339 13.7734 15.3889 13.7734C14.9439 13.7734 14.5032 13.8611 14.092 14.0314C13.6809 14.2017 13.3073 14.4513 12.9926 14.766C12.6779 15.0807 12.4283 15.4543 12.258 15.8655C12.0877 16.2766 12 16.7173 12 17.1623",
    stroke: "#B7C9F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 17.1619C11.9998 17.6069 12.0874 18.0476 12.2577 18.4588C12.428 18.8699 12.6777 19.2435 12.9924 19.5582C13.307 19.8729 13.6806 20.1225 14.0918 20.2928C14.503 20.4631 14.9436 20.5508 15.3887 20.5508",
    stroke: "#B7C9F7",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.9392C12 24.3843 12.0877 24.8249 12.258 25.2361C12.4283 25.6473 12.6779 26.0209 12.9926 26.3355C13.3073 26.6502 13.6809 26.8999 14.0921 27.0702C14.5032 27.2405 14.9439 27.3281 15.3889 27.3281C15.834 27.3281 16.2747 27.2405 16.6858 27.0702C17.097 26.8999 17.4706 26.6502 17.7852 26.3355C18.0999 26.0209 18.3496 25.6473 18.5199 25.2361C18.6902 24.8249 18.7778 24.3843 18.7778 23.9392",
    stroke: "#B7C9F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7776 23.9397C18.7776 23.4946 18.6899 23.054 18.5196 22.6428C18.3493 22.2316 18.0997 21.8581 17.785 21.5434C17.4703 21.2287 17.0967 20.9791 16.6855 20.8087C16.2744 20.6384 15.8337 20.5508 15.3887 20.5508",
    stroke: "#B7C9F7",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3887 11.5156V29.5897",
    stroke: "#B7C9F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7778 14L41.7778 14",
    stroke: "#B7C9F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7778 28H49.7778",
    stroke: "#B7C9F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7778 21L49.7778 21",
    stroke: "#B7C9F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECheck2);
export default __webpack_public_path__ + "static/media/e-check_2.c378bcb94ff3526c7a1f0300ee07214b.svg";
export { ForwardRef as ReactComponent };